export default {
    init() {
      // JavaScript to be fired on all pages
        $('.hero__content-scrolldown').click(this.scrollDown);
    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
    },
    scrollDown() {
        var y = $(window).scrollTop();
        jQuery('html, body').animate({ scrollTop: y + $(window).height() }, 600);
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js